import React from "react";
import { createPortal } from "react-dom";
import { useIntl } from "react-intl";
import DialogContext from "./DialogContext";

import Button from "../button/Button";

import { useThemeStyles } from "../../store/ui/ThemeProvider";
import "./dialog.scss";

const dialogRoot = document.getElementById("dialog-root") as HTMLElement;

function Dialog() {
  const { dialogs, addDialogRefById } = React.useContext(DialogContext);
  const { dialogStyles } = useThemeStyles();

  const dialogList = dialogs.filter((d) => d.type === "dialog");
  const dialog = dialogList[dialogList.length - 1];

  const { formatMessage } = useIntl();

  const { id, title, text, cancelLabel, cancel, confirmLabel, confirm } =
    dialog || {};

  const ref = React.useRef() as React.RefObject<HTMLDivElement>;
  React.useEffect(() => {
    addDialogRefById(id, ref);
  }, [addDialogRefById, id]);

  if (dialog == null) return null;

  return createPortal(
    <>
      <div className="backing dialog-backing" style={dialogStyles} />
      <div ref={ref} className="dialog" style={dialogStyles}>
        <div className="dialog-content">
          {title && <div className="row title">{title}</div>}
          {text && <div className="row text">{text} </div>}

          <div className="row buttons">
            {confirm && (
              <Button
                buttonType="default"
                title={confirmLabel ?? formatMessage({ id: "button.confirm" })}
                onClick={confirm}
              />
            )}
            {cancel && (
              <Button
                buttonType="cancel"
                title={cancelLabel ?? formatMessage({ id: "button.cancel" })}
                onClick={cancel}
              />
            )}
          </div>
        </div>
      </div>
    </>,
    dialogRoot
  );
}

export default Dialog;
